import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Data, Router, RouterOutlet } from '@angular/router';
import { ILegal, IMenu, IMenuCollection, UilabAppBarModule, UilabNavRailModule } from '@uilab/core-angular';
import { UilabBaseComponentsModule } from '@uilab/base-components-angular';
import { AppComponentService, AuthenticatedUser, AuthenticationService, COMPONENTS_CONFIG } from '@aveva/connect-web-core';
import { AccountWithIcon } from 'erm-sdk';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'erm-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    UilabBaseComponentsModule,
    UilabAppBarModule,
    UilabNavRailModule,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly navRailStorageKey = 'navrail-state';
  public readonly appComponentService = inject(AppComponentService);
  public readonly authenticationService = inject(AuthenticationService);
  public readonly config = inject(COMPONENTS_CONFIG);
  public user?: AuthenticatedUser;
  public account?: AccountWithIcon;
  public legal?: ILegal;
  public collapsed = signal(this.getNavRailStorageState());
  public activeRoute = [];
  public mobileMenu = false;
  public userMenuOptions = [];
  public navRail: IMenuCollection[] = [
  {
    name: 'Dashboard',
    icon: 'view--dashboard',
    linkData: {
      href: '/erm/dashboard',
    },
    type: 'link',
  },
  {
    name: 'Customers',
    icon: 'content--globe',
    linkData: {
      href: '/erm/customers',
    },
    type: 'link',
  },
  {
    name: 'Accounts',
    icon: 'content--cloud',
    linkData: {
      href: '/erm/accounts',
    },
    type: 'link',
  },
  {
    name: 'Environments',
    icon: 'device--communications',
    linkData: {
      href: '/erm/environments',
    },
    type: 'link',
  },
  {
    name: 'DevOps Actions',
    icon: 'content--notes',
    linkData: {
      href: '/erm/devops-actions',
    },
    type: 'link',
  },
  {
    name: '',
    type: 'divider',
  },
  {
    name: 'Alarms',
    icon: 'notifications--fatal-error',
    linkData: {
      href: '/erm/alarms',
    },
    type: 'link',
  }
];

  constructor() {
    this.route.data
      .subscribe((data: Data) => {
        this.account = data['account'];
        this.user = data['user'];

        const accountLabelMenuItem = {
          hasAccount: this.account !== undefined,
          accountLabel: this.account?.name,
          accountIcon: this.account?.icon
        };

        this.userMenuOptions = this.appComponentService.generateUserMenuOption(this.user, accountLabelMenuItem, this.config.myProfileLink);
        this.legal = this.appComponentService.getLegalInfo();
        this.activeRoute = [this.router.url];
      });
  }

  private getNavRailStorageState(): boolean {
    return coerceBooleanProperty(localStorage.getItem(this.navRailStorageKey) ?? true);
  }

  public persistNavRailState(event: boolean): void {
    localStorage.setItem(this.navRailStorageKey, event.toString());
  }

  public navigateToPage(event: string): void {
    this.activeRoute = [event];
    this.router.navigate([event]);
  }

  public menuItemSelected(event: IMenu): void {
    if (event.linkData?.href && event.linkData.href !== '') {
      if (event.linkData.external) {
        window.open(event.linkData.href, '_blank');
      }
      else if (event.linkData.href?.includes('sign-out')) {
        this.signout();
      }
      else {
        this.navigateToPage(event.linkData.href);
      }
    }
  }

  public toggleMobileNav(event: boolean): void {
    if (typeof event === 'undefined') this.mobileMenu = !this.mobileMenu;
    if (typeof event !== 'undefined') this.mobileMenu = event;
  }

  private signout(): void {
    this.authenticationService.signout().then(() => {
      this.router.navigate(['/erm/home']);
    }).catch((error) => {
      alert('Error signing out');
      console.error(error);
    });
  }
  
}
